import React from 'react';
import UserConfirmation from 'js/components/route_utils/UserConfirmation';
import { useDraftContext, draftEventTypes } from '../context/Draft/useDraftContext';

const CONFIRMATION_CONFIGS = {
  dismiss: {
    message:
      'Are you sure you want to exit this editor? All of your current changes will be discarded.',
    eventType: draftEventTypes.DISMISS,
  },
  publish: {
    title: 'Publish changes',
    message: 'Are you sure you want to publish the changes to this Flow?',
    okButtonLabel: 'Publish',
    eventType: draftEventTypes.PUBLISH_CONFIRM,
  },
} as const;

export const DraftConfirmationDialog = () => {
  const {
    showDismissConfirmation,
    setShowDismissConfirmation,
    showPublishConfirmation,
    setShowPublishConfirmation,
    handleEvent,
  } = useDraftContext();

  const handleConfirmation = (type: 'dismiss' | 'publish', confirmed: boolean) => {
    if (type === 'dismiss') {
      if (confirmed) {
        handleEvent(CONFIRMATION_CONFIGS.dismiss.eventType);
      }
      setShowDismissConfirmation(false);
    } else if (type === 'publish') {
      if (confirmed) {
        handleEvent(CONFIRMATION_CONFIGS.publish.eventType);
      }
      setShowPublishConfirmation(false);
    }
  };

  return (
    <>
      {showDismissConfirmation && (
        <UserConfirmation
          {...CONFIRMATION_CONFIGS.dismiss}
          onCancel={() => handleConfirmation('dismiss', false)}
          onConfirm={() => handleConfirmation('dismiss', true)}
        />
      )}
      {showPublishConfirmation && (
        <UserConfirmation
          {...CONFIRMATION_CONFIGS.publish}
          onCancel={() => handleConfirmation('publish', false)}
          onConfirm={() => handleConfirmation('publish', true)}
        />
      )}
    </>
  );
};
